import { reactive } from 'vue';

/**
 * Sesión del anunciante de Seway Plus Negocios.
 *
 * Deliberadamente NO usa el store Vuex `infoNavigation`: ese es el estado de la
 * sesión del ERP (cookies Authorization/Rol/IdRol) y mezclar ahí al anunciante
 * contradiría el aislamiento pedido. Tampoco usa cookies, para que el token no
 * viaje por accidente en las peticiones del ERP.
 */
const CLAVE_TOKEN = 'sp_negocios_token';
const CLAVE_PERFIL = 'sp_negocios_perfil';

function leerPerfilGuardado() {
    try {
        const crudo = window.localStorage.getItem(CLAVE_PERFIL);
        return crudo ? JSON.parse(crudo) : null;
    } catch (e) {
        return null;
    }
}

export const sesion = reactive({
    token: window.localStorage.getItem(CLAVE_TOKEN) || null,
    anunciante: leerPerfilGuardado()
});

export function leerToken() {
    return sesion.token;
}

export function estaAutenticado() {
    return !!sesion.token;
}

/**
 * Guarda la sesión tras un registro o inicio de sesión correcto.
 * El token se guarda PELADO; el prefijo "Bearer" lo pone el interceptor.
 */
export function iniciarSesion(token, anunciante) {
    sesion.token = token || null;
    sesion.anunciante = anunciante || null;

    if (token) {
        window.localStorage.setItem(CLAVE_TOKEN, token);
    } else {
        window.localStorage.removeItem(CLAVE_TOKEN);
    }

    if (anunciante) {
        window.localStorage.setItem(CLAVE_PERFIL, JSON.stringify(anunciante));
    } else {
        window.localStorage.removeItem(CLAVE_PERFIL);
    }
}

export function actualizarAnunciante(anunciante) {
    sesion.anunciante = anunciante || null;
    if (anunciante) {
        window.localStorage.setItem(CLAVE_PERFIL, JSON.stringify(anunciante));
    }
}

export function cerrarSesion() {
    sesion.token = null;
    sesion.anunciante = null;
    window.localStorage.removeItem(CLAVE_TOKEN);
    window.localStorage.removeItem(CLAVE_PERFIL);
}
